export const convertDate = (data: string | number | Date) => {
  const date: Date = new Date(data);
  const year: number = date.getFullYear();
  const month: string = ("0" + (date.getMonth() + 1)).slice(-2);
  const day: string = ("0" + date.getDate()).slice(-2);
  return year + "-" + month + "-" + day;
};
export const convertDateTime = (data: string | number | Date) => {
  const date: Date = new Date(data);
  const year: number = date.getFullYear();
  const month: string = ("0" + (date.getMonth() + 1)).slice(-2);
  const day: string = ("0" + date.getDate()).slice(-2);
  const hour: string = ("0" + date.getHours()).slice(-2);
  const minute: string = ("0" + date.getMinutes()).slice(-2);
  const second: string = ("0" + date.getSeconds()).slice(-2);
  return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
}
export const now = (sep: string) => {
  const date: Date = new Date();
  const year: number = date.getFullYear();
  const month: string = ("0" + (date.getMonth() + 1)).slice(-2);
  const day: string = ("0" + date.getDate()).slice(-2);
  return year + sep + month + sep + day;
};
export const nowKorFormat = () => {
  const date: Date = new Date();
  const year: number = date.getFullYear();
  const month: string = ("0" + (date.getMonth() + 1)).slice(-2);
  const day: string = ("0" + date.getDate()).slice(-2);
  return year + "년 " + month + "월 " + day + "일";
};
export const monthFirstDay = (sep: string) => {
  const date: Date = new Date();
  const year: number = date.getFullYear();
  const month: string = ("0" + (date.getMonth() + 1)).slice(-2);
  return year + sep + month + sep + "01";
};
export const getNowHalf = () => {
  const date = new Date();
  const y = date.getFullYear();
  const m = date.getMonth() + 1;
  let half = "";
  if (m < 7) {
    //상반기
    half = "01";
  } else {
    //하반기
    half = "02";
  }

  return y + half;
};
export const numberFormat = (num: number | undefined) => {
  const option = {
    maximumFractionDigits: 4,
  };
  if (num == undefined || num == null) {
    return 0;
  }
  return Number(num).toLocaleString("ko-KR", option);
};

export const phoneNumberFormat = (num: string): string => {
  const onlyNumbers = num.replace(/[^0-9]/g, ""); // 숫자만 남기기
  const regExp = /^[0-9]{2,3}[0-9]{3,4}[0-9]{4}$/;

  // 유효한 전화번호 형식이 아니라면 필터링
  if (!regExp.test(onlyNumbers)) {
    console.log("유효한 전화번호 형식이 아닙니다.");
    return num.replace(/[^0-9-]/g, ""); // 유효하지 않은 문자는 모두 제거
  }
  let formattedNumber = "";
  // 전화번호가 8자리인 경우 (예: 1234-5678)
  if (onlyNumbers.length === 8) {
    formattedNumber = `${onlyNumbers.substring(0, 4)}-${onlyNumbers.substring(4)}`;
  }
  // 서울 지역번호가 포함된 경우 (02-XXXX-XXXX)
  else if (onlyNumbers.startsWith("02") && onlyNumbers.length >= 9) {
    formattedNumber = `02-${onlyNumbers.substring(2, 6)}-${onlyNumbers.substring(6)}`;
  }
  // 일반적인 10~11자리 전화번호인 경우
  else if (onlyNumbers.length === 10) {
    formattedNumber = `${onlyNumbers.substring(0, 3)}-${onlyNumbers.substring(3, 6)}-${onlyNumbers.substring(6)}`;
  } else if (onlyNumbers.length === 11) {
    formattedNumber = `${onlyNumbers.substring(0, 3)}-${onlyNumbers.substring(3, 7)}-${onlyNumbers.substring(7)}`;
  } else {
    // 번호가 너무 짧거나 길면 그대로 반환
    return onlyNumbers;
  }

  return formattedNumber;
};

// export const phoneNumberFormat = (num: string | undefined) => {
//   if (num == null || num == "" || num == undefined) {
//     return num ? /* 포맷 로직 */ num : ""; // 기본값으로 빈 문자열 반환
//   }
//   const regExp = new RegExp(/^[0-9]{2,3}-^[0-9]{3,4}-^[0-9]{4}/g);
//   if (num.replace(regExp, "").length != 0) {
//     if (checkPhoneNumber(num) == true) {
//       const number: string = num.replace(/[^0-9]/g, "");
//       let tel = "";
//       let seoul = 0;
//       if (number.replace("-", "").length == 8) {
//         // const regExp2 = new RegExp(/^[0-9]{4}-^[0-9]{4}/g);
//         return number.substr(0, 4) + "-" + number.substr(4, 4);
//       }

//       if (number.substring(0, 2).indexOf("02") == 0) {
//         seoul = 1;
//       }
//       if (number.length < 4 - seoul) {
//         return number;
//       } else if (number.length < 7 - seoul) {
//         tel += number.substr(0, 3 - seoul);
//         tel += "-";
//         tel += number.substr(3 - seoul);
//       } else if (number.length < 11 - seoul) {
//         tel += number.substr(0, 3 - seoul);
//         tel += "-";
//         tel += number.substr(3 - seoul, 3);
//         tel += "-";
//         tel += number.substr(6 - seoul);
//       } else {
//         tel += number.substr(0, 3 - seoul);
//         tel += "-";
//         tel += number.substr(3 - seoul, 4);
//         tel += "-";
//         tel += number.substr(7 - seoul);
//       }
//       return tel;
//     } else {
//       console.log("폰아님");
//       const regExp = new RegExp(/[^0-9|^-]*$/);
//       return num.replace(regExp, "");
//     }
//   }
// };
function checkPhoneNumber(number: string) {
  const regExp = new RegExp(/^[0-9|-]*$/);
  if (regExp.test(number) == true) {
    return true;
  } else {
    return false;
  }
}
export const calculateAge = (date: string) => {
  if (date.length != 8) {
    return;
  }
  const inputDate = date.substring(0, 4) + "-" + date.substring(4, 6) + "-" + date.substring(6, 8);

  const birthDate = new Date(inputDate);
  // 생년월일을 '년', '월', '일'로 분리합니다.
  const birthYear = birthDate.getFullYear();
  const birthMonth = birthDate.getMonth();
  const birthDay = birthDate.getDate();

  // 현재 날짜를 가져옵니다.
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();
  const currentDay = currentDate.getDate();

  // 만 나이를 계산합니다.
  let age = currentYear - birthYear;

  // 현재 월과 생일의 월을 비교합니다.
  if (currentMonth < birthMonth) {
    age--;
  }
  // 현재 월과 생일의 월이 같은 경우, 현재 일과 생일의 일을 비교합니다.
  else if (currentMonth === birthMonth && currentDay < birthDay) {
    age--;
  }

  return age;
};
export const base64PreFix = (data: any) => {
  if (data) {
    return "data:image/png;base64," + data;
  }
  return data;
};